export default {
  change: (currentPrice: number | undefined, previousPrice: number | undefined) => (currentPrice ?? 0) - (previousPrice ?? 0),
  percentChange(currentPrice: number | undefined, previousPrice: number | undefined) {
    if (currentPrice == null) return 0;
    const pc = (this.change(currentPrice, previousPrice) / currentPrice) * 100;
    return isNaN(pc) ? 0.0 : pc;
  },
  changeIcon: function (currentPrice: number | undefined, previousPrice: number | undefined) {
    if (this.change(currentPrice, previousPrice) === 0.0) return false;
    if (Math.abs(this.change(currentPrice, previousPrice)) < 5) return false;

    let ch = Math.abs(this.percentChange(currentPrice, previousPrice));

    // special case for change to/from $0, use change in $ as threshold
    if (!isFinite(ch)) {
      ch = Math.abs(this.change(currentPrice, previousPrice));
    }

    const dir = this.change(currentPrice, previousPrice) > 0 ? 'up' : 'down';
    if (ch >= 15) return 'mdi-chevron-triple-' + dir;
    if (ch >= 10) return 'mdi-chevron-double-' + dir;
    if (ch >= 5) return 'mdi-chevron-' + dir;
    return false;
  }
};
